import React from 'react';
import { bool, func, string } from 'prop-types';
import { Input, Label } from 'reactstrap';

/**
 * The idea of this was to reduce the total amount of HTML since I was repeating so much code and to
 * ensure better Accessibility by enforcing that labels match the ids of their input fields.
 *
 * A dumb input field has four required props:
 *   friendlyname (string): the name that the user sees in the label
 *   id (string): the unique identifier for the label and input field
 *   onChange (function): the higher order property function which manages state in the
 *     component which calls this Component
 *
 * The optional props allow for validation and can be added/removed as needbe.
 *   value (string): the value of the input field (Can be empty)
 *   hasError (string): The error message to display to the user - and allows the component to style
 *     with a red border
 *   isRequired (boolean): Adds an asterisk to the label to indicate required to the user
 *   maxLength (string): A value to limit user input to the number of characters
 *   onBlur (function): the higher order property function which allows for custom validation
 *     functions. Note that you can chain multiple validation functions together (Bottom
 *     up priority). For instance the following would first prioritize the required check,
 *     and then afterwards check the regular expression:
 *     onBlur={e => { this.validateEmail(e); this.validateRequired(e); }}
 */
const CustomInputField = ({
  friendlyname,
  hasError = null,
  id,
  isRequired = false,
  maxLength = null,
  onBlur,
  onChange,
  value
}) => (
  <div>
    <Label for={id}>
      {friendlyname}
      {isRequired ? '*' : ''}
    </Label>
    <Input
      className={hasError ? 'is-invalid' : ''}
      type="text"
      id={id}
      maxLength={maxLength}
      name={id}
      value={value}
      friendlyname={friendlyname}
      onBlur={onBlur}
      onChange={onChange}
    />
    {hasError && <p className="color-danger my-0">{hasError}</p>}
  </div>
);

CustomInputField.propTypes = {
  friendlyname: string.isRequired,
  id: string.isRequired,
  onChange: func.isRequired,
  hasError: string,
  isRequired: bool,
  maxLength: string,
  onBlur: func,
  value: string
};

CustomInputField.defaultProps = {
  hasError: null,
  isRequired: false,
  maxLength: null,
  onBlur: () => null,
  value: ''
};

export default CustomInputField;
